// extracted by mini-css-extract-plugin
module.exports = {"item":"Ts2N2","withLink":"_2sdhu","icon":"ERKTD","link":"_2njFm","theme_white":"_9Q4II"};